import React, { useState } from "react";
import axios from "axios";
import "./email.scss";
import peigon from "../../assets/svg/Pigeon (1).png";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function Email() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleEmailSubmit = async () => {
    setIsSubmitted(true);

    if (!email || !email.includes("@")|| !email.includes(".") ) {
      toast.error("PLEASE ENTER A VALID EMAIL ADDRESS.");
      return;
    }

    try {
      const response = await axios.post("https://www.api.v1.cults.gg/api/waitlist/addEmail", {
        emailAddress: email,
      });

      if (response.data) {
        toast.success("EMAIL SUCCESSFULLY SUBMITTED TO WAITLIST.");
        setEmail("");
      } else {
        setIsSubmitted(false);
        setEmail("");
        toast.error("THIS EMAIL HAS ALREADY REQUESTED THE CAREER PIGEON.");
      }
    } catch (error) 
   {
    setIsSubmitted(false);
    setEmail("");
      toast.error("EMAIL ALREADY EXISTS IN WAITLIST.");
    }
  };

  return (
    <div className="email-wrap">
      <h4>BE THE FIRST TO GET NOTIFIED FOR ALLOWLIST!</h4>
      <div className="input-wrap">
        <input
          type="text"
          placeholder="TYPE EMAIL ADDRESS..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button onClick={handleEmailSubmit}>
          <img src={peigon} alt="Pigeon" width={50} height={50} />
          {isSubmitted ? "REQUEST SENT" : "REQUEST CARRIER PIGEON"}
        </button>
      </div>

      {/* Toasts mount here */}
      <ToastContainer position="top-center" autoClose={2500} />
    </div>
  );
}

export default Email;
